import Fuse from "fuse.js";
//#region src/combobox/createComboboxItemStore.ts
/**
* Reactive registry of combobox items, keyed by value.
*
* Items register themselves from `ComboboxItemText`, so labels are only known
* after the items mount. Readers (`Tags`, `Select`, `SelectValue`) subscribe with
* `useSyncExternalStore`, so they re-render as soon as labels arrive.
*
* Items are never removed, because a selected item needs to keep its label even
* after it leaves the list (ex. from a new search).
*/
const createComboboxItemStore = () => {
	const items = /* @__PURE__ */ new Map();
	const listeners = /* @__PURE__ */ new Set();
	const fuse = new Fuse([], {
		keys: ["searchable"],
		threshold: .3
	});
	let version = 0;
	let isIndexStale = false;
	const upsert = (item) => {
		const existing = items.get(item.id);
		const isSearchableChanged = existing?.searchable !== item.searchable;
		if (!isSearchableChanged && existing?.label === item.label) return;
		isIndexStale ||= isSearchableChanged;
		items.set(item.id, item);
		version += 1;
		listeners.forEach((listener) => listener());
	};
	const subscribe = (listener) => {
		listeners.add(listener);
		return () => {
			listeners.delete(listener);
		};
	};
	const getVersion = () => version;
	const getItems = () => items;
	const search = (query) => {
		if (isIndexStale) {
			fuse.setCollection([...items.values()]);
			isIndexStale = false;
		}
		return fuse.search(query);
	};
	return {
		upsert,
		subscribe,
		getVersion,
		getItems,
		search
	};
};
//#endregion
export { createComboboxItemStore };
